import styles from './styles/AttributeRowImage.module.scss';
import Image, { ImageProps } from 'components/Image';

export default function AttributeRowImage(props: Omit<ImageProps, 'className'>) {
  return (
    <div className={styles.Container}>
      <Image className={styles.Image} {...props} />
    </div>
  );
}
